import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './HelpModal.css';

const HelpModal = ({ show, title, content, onClose }) => {
  if (!show) return null;

  return (
    <div className="help-modal-overlay" onClick={onClose}>
      <div className="help-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="help-modal-header">
          <h3>{title}</h3>
          <button className="help-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div 
          className="help-modal-body" 
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <div className="help-modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;

